import React, { useState } from "react";
import { DesktopDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { TextField } from "@mui/material";

export const FormikDatePicker = ({
  onChange,
  minDate,
  maxDate,
  label,
  required,
  fieldValue,
  disabled,
  className,
  disablePast,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [open, setOpen] = React.useState(false);
  const minLDate = minDate;
  const maxLDate = maxDate;
  const requiredField = required || false;

  const handleDateChange = (date) => {
    if (date) {
      let formatDate = new Date(date);
      let month = formatDate.getMonth() + 1;
      let day = formatDate.getDate();
      let year = formatDate.getFullYear();

      // Add leading zeros to month and day if needed
      let formattedMonth = month.toString().padStart(2, "0");
      let formattedDay = day.toString().padStart(2, "0");

      let dateMDY = `${formattedMonth}-${formattedDay}-${year}`;
      /* Date converted to MM-DD-YYYY format */
      setSelectedDate(date);
      onChange(dateMDY); // Call the onChange callback with the selected date
    }
  };

  const handleInputChange = (event) => {
    if (!disabled) {
      event.preventDefault();
      setOpen(true);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label={label}
        value={selectedDate}
        disablePast={disablePast}
        onChange={handleDateChange}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            onBlur={fieldValue.onBlur}
            InputLabelProps={{
              className: `label-style-create-franchisee ${
                requiredField ? "required-label" : ""
              }`,
            }}
            sx={{ width: "100%" }}
            {...params}
            onClick={handleInputChange}
            inputProps={{ ...params.inputProps, readOnly: true }}
            className={
              disabled &&
              `custom-datepicker input-field-styling ${className} ${
                requiredField ? "required-field" : ""
              }`
            }
          />
        )}
        inputProps={{ readOnly: true }}
        minDate={minLDate}
        maxDate={maxLDate}
        open={open}
        onClose={() => setOpen(false)}
        inputFormat="MM-dd-yyyy"
      />
    </LocalizationProvider>
  );
};
